/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Severity level for findings produced by this rule.
 */
export const RiskCustomDetectionRuleSeverity = {
  Info: "info",
  Low: "low",
  Medium: "medium",
  High: "high",
  Critical: "critical",
} as const;
/**
 * Severity level for findings produced by this rule.
 */
export type RiskCustomDetectionRuleSeverity = OpenEnum<
  typeof RiskCustomDetectionRuleSeverity
>;

export type RiskCustomDetectionRule = {
  /**
   * When the custom detection rule was created.
   */
  createdAt: Date;
  /**
   * Description of what the rule detects.
   */
  description: string;
  /**
   * CEL detection predicate: a boolean expression over message fields whose true verdict produces a finding. Supersedes regex.
   */
  detectionExpr?: string | undefined;
  /**
   * The custom detection rule ID.
   */
  id: string;
  /**
   * Legacy RE2-compatible regex pattern (read-only). Live for existing rules; evaluated as content.match(regex) when detection_expr is empty. New rules author detection_expr instead.
   */
  regex: string;
  /**
   * Stable rule identifier, prefixed with `custom.`.
   */
  ruleId: string;
  /**
   * Severity level for findings produced by this rule.
   */
  severity: RiskCustomDetectionRuleSeverity;
  /**
   * Human-readable title for the rule.
   */
  title: string;
  /**
   * When the custom detection rule was last updated.
   */
  updatedAt: Date;
};

/** @internal */
export const RiskCustomDetectionRuleSeverity$inboundSchema: z.ZodMiniType<
  RiskCustomDetectionRuleSeverity,
  unknown
> = openEnums.inboundSchema(RiskCustomDetectionRuleSeverity);

/** @internal */
export const RiskCustomDetectionRule$inboundSchema: z.ZodMiniType<
  RiskCustomDetectionRule,
  unknown
> = z.pipe(
  z.object({
    created_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    description: z.string(),
    detection_expr: z.optional(z.string()),
    id: z.string(),
    regex: z.string(),
    rule_id: z.string(),
    severity: RiskCustomDetectionRuleSeverity$inboundSchema,
    title: z.string(),
    updated_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      "created_at": "createdAt",
      "detection_expr": "detectionExpr",
      "rule_id": "ruleId",
      "updated_at": "updatedAt",
    });
  }),
);

export function riskCustomDetectionRuleFromJSON(
  jsonString: string,
): SafeParseResult<RiskCustomDetectionRule, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RiskCustomDetectionRule$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RiskCustomDetectionRule' from JSON`,
  );
}
